import { render } from "./StudyMaterialAdmin.vue?vue&type=template&id=30b7306c&scoped=true"
import script from "./StudyMaterialAdmin.vue?vue&type=script&lang=js"
export * from "./StudyMaterialAdmin.vue?vue&type=script&lang=js"

import "./StudyMaterialAdmin.vue?vue&type=style&index=0&id=30b7306c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b7306c"]])

export default __exports__